import { render, staticRenderFns } from "./AGPSApprovalClosure.vue?vue&type=template&id=4184526e"
import script from "./AGPSApprovalClosure.vue?vue&type=script&lang=js"
export * from "./AGPSApprovalClosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports